import Vue from 'vue'
import { URL_USER_REQUESTS } from '@/constants/urls.js'
import { REQUEST_STATUSES } from '@/constants/business.js'
import { USER_REQUESTS, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [USER_REQUESTS.STATE.REQUESTS]: {
    [REQUEST_STATUSES.CREATED]: null,
    [REQUEST_STATUSES.INPROCESS]: null,
    [REQUEST_STATUSES.REJECTED]: null,
    [REQUEST_STATUSES.APPROVED]: null
  },
  [USER_REQUESTS.STATE.CURRENT_REQUEST]: null
}

const actions = {
  async [USER_REQUESTS.ACTIONS.GET_USER_REGISTRATION_REQUESTS] ({ dispatch, commit }, params) {
    const status = params.status
    const model = {
      url: `${Vue.getIdentityHost()}${URL_USER_REQUESTS}?${Vue.helpers.getQueryParamsString(params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(USER_REQUESTS.MUTATIONS.GET_USER_REGISTRATION_REQUESTS, {
      requests: resp.data,
      status
    })
  },
  async [USER_REQUESTS.ACTIONS.GET_USER_REQUEST_INFO] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USER_REQUESTS}/${model.requestId}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(USER_REQUESTS.MUTATIONS.GET_USER_REQUEST_INFO, resp.data)
  },
  async [USER_REQUESTS.ACTIONS.PROCESS_USER_REGISTRATION_REQUEST] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USER_REQUESTS}/${model.requestId}/process`,
      model: model.process
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [USER_REQUESTS.ACTIONS.CLEAR_USER_REGISTRATION_REQUESTS] ({ commit }, status) {
    commit(USER_REQUESTS.MUTATIONS.CLEAR_USER_REGISTRATION_REQUESTS, status)
  },
  async [USER_REQUESTS.ACTIONS.CLEAR_USER_REQUEST_INFO] ({ commit }) {
    commit(USER_REQUESTS.MUTATIONS.CLEAR_USER_REQUEST_INFO)
  }
}

const mutations = {
  [USER_REQUESTS.MUTATIONS.GET_USER_REGISTRATION_REQUESTS] (state, model) {
    state[USER_REQUESTS.STATE.REQUESTS][model.status] = model.requests
  },
  [USER_REQUESTS.MUTATIONS.GET_USER_REQUEST_INFO] (state, request) {
    state[USER_REQUESTS.STATE.CURRENT_REQUEST] = request
  },
  [USER_REQUESTS.MUTATIONS.CLEAR_USER_REGISTRATION_REQUESTS] (state, status) {
    state[USER_REQUESTS.STATE.REQUESTS][status] = null
  },
  [USER_REQUESTS.MUTATIONS.CLEAR_USER_REQUEST_INFO] (state) {
    state[USER_REQUESTS.STATE.CURRENT_REQUEST] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
